import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getSummary = store => store[NAME].summary;
export const getSkillMatrix = store => store[NAME].skillMatrix;
export const getSuggestions = store => store[NAME].suggestions;